import reducer from '../api/reducer';
export default {
  data() {
    return {
      startLogin: '', // 登陆组件
      runwx: '', // 微信分享组件
      islogin: 0, // 判断是否登录
      personId: 0, // 用户ID
      yqCounts: 0, // 每日邀请次数
      day_invite_3: 0, // 邀请任务完成
      day_login_act: 0, // 每日是否已签到
      active_val_ok: 0, // 每日是否领取活跃度
      score: 0, // 积分总数
      addressId: 0, // 填写地址ID
      shareUrl: null, // 分享链接

      loginUserName: '', // 登陆人姓名

      mobilePhone: '', // 中奖人手机号
      userNameP: '', // 中奖人姓名
      addressP: '', // 中奖人地址

      selectItem1: '----请选择区服----',
      selectItem2: '----请选择角色----',
      // 幸运勇士
      lukyPerson: [
        {
          who: 'LSIJEGKILENKW',
          name: '升星宝石'
        }
      ]
    };
  },
  methods: {
    GetQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');

      if (window.location.href.indexOf('?') !== -1) {
        var r = window.location.search.substr(1).match(reg);
      }
      if (window.location.href.indexOf('#') !== -1) {
        var r = window.location.href.split('#')[1].match(reg);
      }

      if (r != null) return unescape(r[2]); return false;
    },
    actionsClick(...arg) {
      reducer(this)(...arg);
    },
    $$() {
      return document.querySelector.bind(document);// $$("#xxx")
    }

  }
}
